import { ReactNode } from 'react';

/** 属性定義 */
type Props = {
  children: ReactNode;
  htmlFor?: string;
  className?: string;
};

/**
 * コンポーネント描画
 * @param 属性定義
 * @returns コンポーネント
 */
const AtInputLabel = ({ children, htmlFor, className }: Props) => {
  return (
    <label className={`atinputlabel ${className}`} htmlFor={htmlFor}>
      {children}
    </label>
  );
};
/** 初期値の設定 */
AtInputLabel.defaultProps = { htmlFor: '', className: '' };
export default AtInputLabel;
